import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";
import jwtDecode from "jwt-decode";
import Axios from "axios";

import { url } from "../../../../../config/config";
import { authorLogin } from "../../../../../redux/action/action";
import LoginInfo from "../LoginInfo/LoginInfo";
import Publish from "../../../../../Assets/Logo/publish.png";
import Sell from "../../../../../Assets/Logo/sell.png";
import LoginForm from "../LoginForm/LoginForm";
import { useStyles } from "./AuthorLogin.css";

class AuthorLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        email: "",
        password: "",
      },
      error: {
        emailError: "",
        passwordError: "",
      },
      name: "",
      token: "",
      options: {
        type: "Author",
        description: "What We have for Author",
        feature1: {
          icon: Publish,
          details: "Publish Book",
        },
        feature2: {
          icon: Sell,
          details: "Sell Book",
        },
      },
      loading: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });
  };

  checkError = (EmailError, PasswordError) => {
    let emailError = EmailError;
    let passwordError = PasswordError;

    if (this.state.data.password.length < 8) {
      passwordError = "Password must be minimum of 8 characters";
    }

    if (emailError || passwordError) {
      this.setState({
        error: {
          emailError,
          passwordError,
        },
      });
      return true;
    } else {
      this.setState({
        error: {
          emailError: "",
          passwordError: "",
        },
      });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      this.setState({ loading: true });
      const response = await Axios.post(
        `${url}/api/auth/author`,
        this.state.data
      );
      if (response.data.emailError || response.data.passwordError) {
        this.setState({ loading: false });
        this.checkError(response.data.emailError, response.data.passwordError);
      } else {
        if (response.data.token) {
          this.setState({
            token: response.data.token,
          });
        }
      }
    }

    if (this.state.token) {
      try {
        let data = jwtDecode(this.state.token);
        if (!data.isAdmin) {
          this.props.authorLogin(this.state.token);
        } else {
          this.checkError(
            "Invalid email or password",
            "Invalid email or password"
          );
        }
      } catch (error) {
        this.setState({ loading: false });
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <LoginInfo options={this.state.options} />
        </div>
        <Paper className={classes.paper}>
          <LoginForm
            loading={this.state.loading}
            label="Author"
            data={this.state.data}
            error={this.state.error}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
            passwordRecoverUrl="/password/recover/Author"
          />
          <br />
          <div style={{ display: "flex", justifyContent: "center" }}>
            New Author? <Link to="/signup/Author">SignUp</Link>
          </div>
          <br />
          <div className={classes.homeStyle}>
            <Link to="/">Go Home</Link>
          </div>
        </Paper>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    authorLogin: (token) => {
      dispatch(authorLogin(token));
    },
  };
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(useStyles)(AuthorLogin));
